// extracted by mini-css-extract-plugin
module.exports = {"onboard-section":"OnboardProgress_onboard-section__YNbv1","done":"OnboardProgress_done__1Y2BM","active":"OnboardProgress_active__yvyo9","pending":"OnboardProgress_pending__1ydH0"};